import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/library/folders/:folderId/members/:memberId`;

type DeleteFolderLibraryMemberResponse = { status: boolean };
type DeleteFolderLibraryMemberDTO = {
  memberId: number;
  folderId: number;
};

export const deleteFolderLibraryMember = ({
  memberId,
  folderId,
}: DeleteFolderLibraryMemberDTO): Promise<DeleteFolderLibraryMemberResponse> => {
  const URL = generateRoutePath(url, { folderId, memberId });

  return axios.delete(URL);
};

type DeleteAddFolderLibraryMemberOptions = {
  config?: MutationConfig<typeof deleteFolderLibraryMember>;
};

export const useDeleteFolderLibraryMember = ({
  config,
}: DeleteAddFolderLibraryMemberOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props) => deleteFolderLibraryMember(props),
  });
};
